import { logError } from 'client/javascript/util/logger';
import { HIDDEN_CLASS } from 'client/javascript/pages/product_details/constants';
import { geoData } from 'client/javascript/geo';

export const renderNecessaryModulesBasedOnUserGeolocation = async (config) => {
  try {
    const { countryCode } = await geoData;
    const { locationAttributeName = 'conditionsToShow', nodes = [] } = config;

    if (!nodes.length) {
      return false;
    }

    const DEFAULT_MODULE_TYPE = 'default';
    const OPTIONAL_MODULE_TYPE = 'optional';
    let willShowOptionalModule = false;

    const modules = {
      [DEFAULT_MODULE_TYPE]: [],
      [OPTIONAL_MODULE_TYPE]: []
    };

    nodes.forEach((node) => {
      const conditionsToShow = node.dataset[locationAttributeName];
      const isConditionExist = conditionsToShow && Boolean(conditionsToShow.trim().length);
      const listOfCountryCode = isConditionExist ? JSON.parse(conditionsToShow) : [];

      if (!willShowOptionalModule) {
        willShowOptionalModule = listOfCountryCode.includes(countryCode);
      }

      modules[isConditionExist ? OPTIONAL_MODULE_TYPE : DEFAULT_MODULE_TYPE].push({
        nodeReference: node,
        listOfCountryCode,
        shouldShowThisNode: listOfCountryCode.includes(countryCode)
      });
    });

    const optionalModulesAmountForCurrentUserGeolocation = modules[OPTIONAL_MODULE_TYPE].filter(
      ({ shouldShowThisNode }) => shouldShowThisNode
    ).length;

    if (optionalModulesAmountForCurrentUserGeolocation > 1) {
      logError(
        `[Shared modules] renderNecessaryModulesBasedOnUserGeolocation failed: in the Contentful selected for then 1 optional module for ${countryCode} country`
      );
    } else {
      modules[OPTIONAL_MODULE_TYPE].forEach(({ shouldShowThisNode, nodeReference }) => {
        if (shouldShowThisNode) {
          nodeReference.classList.remove(HIDDEN_CLASS);
        } else {
          nodeReference.remove();
        }
      });

      modules[DEFAULT_MODULE_TYPE].forEach(({ nodeReference }, key) => {
        /**
         * If the content manager setup more than one default sticky bars remove all of them except first or
         * if the optional module should be shown, remove all of them */
        if (willShowOptionalModule || key > 0) {
          nodeReference.remove();
        } else {
          nodeReference.classList.remove(HIDDEN_CLASS);
        }
      });
    }
  } catch (error) {
    logError(`[Shared modules] renderNecessaryModulesBasedOnUserGeolocation failed: ${error.message}`, error);
  }
};
